import { setDocTitle } from "../../../functions/HelperFuncs";
import i18n from "../../../functions/i18next";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      company: this.$store.state.company,
    };
  },
  created() {
    setDocTitle(i18n.t("error.invite_accepted"), this);
  },
  mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  },
};
